/**
 * @file Picks the widest level a caller can read: Org when they can read Org,
 * else the team level when `teamsOfUser` gives them at least one team,
 * else My sales. Consumer: `useAnalyticsPanelView`, which chooses it once for
 * the Orders, Invoicing, Reports and Metrics tabs. A caller with no team never
 * gets the team level, because the server refuses it `noTeam`.
 */
import type { AnalyticsScopeLevel, DocId } from '#types';

import type { AnalyticsRights } from './index.types';

export const analyticsWidestLevel = (
  rights: Pick<AnalyticsRights, 'canReadOrg'>,
  teams: readonly DocId[],
): AnalyticsScopeLevel =>
  rights.canReadOrg ? 'org' : teams.length > 0 ? 'team' : 'self';
